export const anyToString = (v: unknown): string => {
	return String(v) === "[object Object]" ? JSON.stringify(v, null, 1) : String(v);
};
